import { DateTime, Duration } from "@/lib/dates"
import { floorTo } from "@/lib/math"

export function calculate(diff: Duration): {
	hours: number
	minutes: number
} {
	let hours = Math.floor(diff.hours)
	let minutes = Math.floor(floorTo(diff.minutes, 15))

	return {
		hours,
		minutes,
	}
}

export function dateDiff(from: Date, to: Date): Duration {
	return DateTime.fromJSDate(from).diff(DateTime.fromJSDate(to), [
		"hours",
		"minutes",
	])
}
